import React from "react";
import { Link } from "react-router-dom";
import { MapPin, CalendarDays, Users, CheckCircle2, Wrench, ShieldCheck } from "lucide-react";

export default function Home() {
  return (
    <div className="space-y-10">
      {/* Hero */}
      <section className="text-center space-y-4">
        <div className="flex items-center justify-center">
          <img
            src="/logo.png"
            alt="Urban Unity Network"
            className="w-28 h-28 md:w-32 md:h-32"
          />
        </div>

        <h1 className="text-3xl md:text-5xl font-semibold">
          Urban Unity Network
        </h1>

        <p className="text-white/70 max-w-2xl mx-auto">
          Urban Unity Network connects residents, local groups, and services in your neighbourhood — making it easier to find support, events, and opportunities nearby.
        </p>
      </section>

      {/* Circular icons row */}
      <section className="flex items-center justify-center">
        <div className="flex gap-6 md:gap-10">
          <Link
            to="/map"
            className="group flex flex-col items-center gap-2"
            aria-label="Go to Map"
          >
            <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-white/10 border border-white/15 flex items-center justify-center group-hover:bg-white/15 transition">
              <MapPin className="w-8 h-8 md:w-9 md:h-9 text-[#E63946]" />
            </div>
            <span className="text-sm md:text-base font-semibold">Map</span>
          </Link>

          <Link
            to="/events"
            className="group flex flex-col items-center gap-2"
            aria-label="Go to Events"
          >
            <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-white/10 border border-white/15 flex items-center justify-center group-hover:bg-white/15 transition">
              <CalendarDays className="w-8 h-8 md:w-9 md:h-9 text-[#E63946]" />
            </div>
            <span className="text-sm md:text-base font-semibold">Events</span>
          </Link>

          <Link
            to="/community"
            className="group flex flex-col items-center gap-2"
            aria-label="Go to Community"
          >
            <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-white/10 border border-white/15 flex items-center justify-center group-hover:bg-white/15 transition">
              <Users className="w-8 h-8 md:w-9 md:h-9 text-[#E63946]" />
            </div>
            <span className="text-sm md:text-base font-semibold">Community</span>
          </Link>
        </div>
      </section>

      {/* Trust cards */}
      <section className="grid gap-4 md:grid-cols-3">
        <div className="rounded-2xl bg-white/5 border border-white/10 p-5">
          <div className="flex items-center gap-3">
            <CheckCircle2 className="w-6 h-6 text-[#E63946]" />
            <h3 className="font-semibold text-lg">What you can do here</h3>
          </div>
          <p className="text-white/70 mt-2 text-sm">
            Search services, discover local activities, and submit events or locations to help your community.
          </p>
        </div>

        <div className="rounded-2xl bg-white/5 border border-white/10 p-5">
          <div className="flex items-center gap-3">
            <Wrench className="w-6 h-6 text-[#E63946]" />
            <h3 className="font-semibold text-lg">Built for residents</h3>
          </div>
          <p className="text-white/70 mt-2 text-sm">
            Simple, practical, and designed for everyday use — not just organisations.
          </p>
        </div>

        <div className="rounded-2xl bg-white/5 border border-white/10 p-5">
          <div className="flex items-center gap-3">
            <ShieldCheck className="w-6 h-6 text-[#E63946]" />
            <h3 className="font-semibold text-lg">Moderated for trust</h3>
          </div>
          <p className="text-white/70 mt-2 text-sm">
            Submissions are reviewed before appearing, helping keep info accurate and community-focused.
          </p>
        </div>
      </section>
    </div>
  );
}
